import Checkbox from './FormCheckbox/index.js';
import { Dropdown } from './FormDropdown/index.js';
import DynamicField from './FormDynamicField/index.js';
import FormFeedback from './FormFeedback/index.js';
import FormField from './FormField/index.js';
import FormFieldError from './FormFieldError/index.js';
import FieldStatus from './FormFieldStatus/index.js';
import FormTypeahead from './FormTypeahead/index.js';
import FormInput from './FormInput/index.js';
import FormLabel from './FormLabel/index.js';
import Radio from './FormRadio/index.js';
import FormSearch from './FormSearch/index.js';
import FormSwitch from './FormSwitch/index.js';
import FormTextArea from './FormTextArea/index.js';
import Uploader from './FormUploader/index.js';
import Requirement from './FormRequirement/index.js';
import FormFormatInput from './FormFormatInput/index.js';
import utils from './utils/index.js';

var Form = {
  Checkbox: Checkbox,
  Dropdown: Dropdown,
  DynamicField: DynamicField,
  Feedback: FormFeedback,
  Field: FormField,
  FieldError: FormFieldError,
  FieldStatus: FieldStatus,
  FormatInput: FormFormatInput,
  Input: FormInput,
  Label: FormLabel,
  Radio: Radio,
  Requirement: Requirement,
  Search: FormSearch,
  Switch: FormSwitch,
  TextArea: FormTextArea,
  Typeahead: FormTypeahead,
  Uploader: Uploader,
  Validate: Requirement,
  utils: utils
};

export { Form as default };
//# sourceMappingURL=index.js.map
